var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.237,
    height: 20,
    viewBox: "0 0 23.237 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_944",
    "data-name": "Rectangle 944",
    width: 23.237,
    height: 20,
    fill: "#ff8b8b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2291",
    "data-name": "Group 2291",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2290",
    "data-name": "Group 2290",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M21.329,1.623A6.053,6.053,0,0,0,17.137,0,6.215,6.215,0,0,0,13.47,1.176a5.653,5.653,0,0,0-1.852,2.341A5.652,5.652,0,0,0,9.767,1.176,6.218,6.218,0,0,0,6.1,0h0A6.053,6.053,0,0,0,1.907,1.623,6.5,6.5,0,0,0,0,6.5,8.65,8.65,0,0,0,2.657,12.48a30.8,30.8,0,0,0,5.076,4.1c1.8,1.251,3.885,2.553,3.885,3.424,0-.87,2.082-2.173,3.885-3.424a30.791,30.791,0,0,0,5.077-4.1A8.65,8.65,0,0,0,23.237,6.5a6.5,6.5,0,0,0-1.908-4.874",
    transform: "translate(0 0)",
    fill: "#ff8b8b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.378a60c03a2cbdb0c022b85a9c47c23d.svg";
export { ForwardRef as ReactComponent };